import { render, staticRenderFns } from "./progress_bar_widget.vue?vue&type=template&id=87ae2ac6&scoped=true"
import script from "./progress_bar_widget.vue?vue&type=script&lang=js"
export * from "./progress_bar_widget.vue?vue&type=script&lang=js"
import style0 from "./progress_bar_widget.vue?vue&type=style&index=0&id=87ae2ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ae2ac6",
  null
  
)

export default component.exports